import { plotImageUrl } from './housingUi'

type Props = {
  className?: string
  mapId: number
  plotId: string
}

const PlotImage = ({ className, mapId, plotId }: Props) => {
  return (
    <img className={className} src={plotImageUrl(mapId, plotId)} alt={plotId} />
  )
}

export default PlotImage
